export {}

export const COLOR_TILE_SELECTED = 'rgba(79,58,43,0.80)';
export const COLOR_TILE_SELECTED_SECONDARY = 'rgba(255, 179, 0, 0.8176)';

export const COLOR_TREASURE_NORMAL = "#aae3a7"

export const COLOR_TREASURE_NORMAL_2 = "#c7c6b4"
export const COLOR_TREASURE_UNNORMAL = "#aae3a7"
export const COLOR_TREASURE_RARE = "#4d9dfc";
export const COLOR_TREASURE_EPIC = "#ce47c5";
export const COLOR_TREASURE_LEGEND = "#ecaf10";
export const COLOR_TREASURE_MYTHIC = "rgba(23,175,151,0.67)";
